import React from 'react';

import { IIconProps, TIconType } from '../interface';

const ChevronUpIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-testid='chevron-up'
			fill='none'
			height='8'
			viewBox='0 0 12 8'
			width='12'
			{...props?.innerSvgProps}
		>
			<path
				d='M12 6.62489L6 0.624887L0 6.62489L0.749866 7.37476L6 2.12462L11.2501 7.37476L12 6.62489Z'
				fill='#2E2E6B'
			/>
		</svg>
	);
};

export default ChevronUpIcon;
